import React from 'react';
import { ArrowRight, ShieldCheck, Zap } from 'lucide-react';

export default function HuntrHero() {
  return (
    <section className="relative bg-[#0B0B0B] pt-32 lg:pt-40 pb-16 lg:pb-24 overflow-hidden">
      <div className="absolute inset-0 fine-grid opacity-25" />
      <div className="absolute top-0 right-0 w-2/3 h-full bg-[radial-gradient(circle_at_top_right,rgba(37,99,235,0.20),transparent_60%)]" />

      <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[1.15fr_1fr] gap-14 items-center">
        <div>
          <div className="inline-flex items-center gap-2.5 mb-7 px-4 py-2 rounded-lg border border-[#3B82F6]/30 bg-[#2563EB]/10">
            <Zap className="w-3.5 h-3.5 text-[#3B82F6]" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-white/80">
              Huntr · The Real Leads Generation Engine
            </span>
          </div>

          <h1
            className="font-display font-bold text-white tracking-tight leading-[1.05]"
            style={{ fontSize: 'clamp(2.3rem, 4.8vw, 4.2rem)' }}
          >
            We do the work.<br />
            <span className="text-[#3B82F6]">You cash the cheques.</span>
          </h1>

          <p className="mt-7 text-white/60 text-base lg:text-lg leading-relaxed font-light max-w-xl">
            Huntr is our AI-powered B2B prospecting and outbound engine. Describe your ideal customer
            in plain English — Huntr researches 200M+ companies and 600M+ profiles, writes the
            outreach, handles the replies, and books qualified meetings straight onto your calendar.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#huntr-pricing"
              className="group inline-flex items-center justify-center gap-2 px-8 h-14 rounded-lg text-sm font-semibold bg-[#2563EB] text-white hover:bg-[#1D4ED8] transition-colors duration-300 blue-glow"
            >
              See Launch Packages
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#huntr-start"
              className="inline-flex items-center justify-center px-8 h-14 rounded-lg text-sm font-semibold border border-white/20 text-white hover:border-white/50 transition-colors duration-300"
            >
              Request Access
            </a>
          </div>

          <p className="mt-6 flex items-center gap-2 text-xs text-white/45">
            <ShieldCheck className="w-4 h-4 text-[#3B82F6]" />
            Guaranteed hot leads every working day — or your money back.
          </p>
        </div>

        <div className="rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-sm p-7 lg:p-8">
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6] mb-6">Engine Capacity</p>
          <div className="space-y-6">
            {[
              { k: '200M+', v: 'Companies continuously researched' },
              { k: '600M+', v: 'Decision-maker profiles indexed' },
              { k: '1,000', v: 'Hot leads worked per day, per client' },
              { k: '7 days', v: 'From onboarding to live outreach' },
            ].map((s) => (
              <div key={s.v} className="pb-5 border-b border-white/10 last:border-0 last:pb-0">
                <div className="font-display font-bold text-3xl text-white">{s.k}</div>
                <div className="text-xs text-white/50 mt-1.5">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}